import { Template } from "./template.js";
import {Page4_addmodem} from "../component.js";

const Left_menu = {
  data() {
    return {
      perPage: globalConstants.linesPerPageLeftMenu,
      currentPage: 1,
      filter: null,
      fields: [
        {
          key: "tube_name",
          label: this.$t("addModem.tube"),
          sortable: true,
        },
        {
          key: "serial",
          label: this.$t("addModem.modemsSN"),
          sortable: true,
        },
        {
          key: "action",
          label: "",
        },
        {
          key: "delete",
          label: "",
        },
      ],
      options: [
        {
          key: "serial",
          namelabel: this.$t("addModem.serNumber"),
          typefield: "text",
          info: "",
        },
        {
          key: "full_serial",
          namelabel: this.$t("addModem.fullSerNumber"),
          typefield: "text",
          info: "",
        },
      ],
      comment_types:[
        {
          key: "tube_comment",
          namelabel: this.$t("addModem.tubeComment"),
          typefield: "text",
          info: "",
        },
        {
          key: "modem_comment",
          namelabel: this.$t("addModem.modemComment"),
          type: "text",
          info: "",
        },
      ],
      selected_phones: [],
      tube_coords: null,
      modem_coords: null,
      editing_tube: null,
      map: null,
      line: null,
      marker: null,
      message: "",
      coords: '',
    };
  },
  props: {
    tubes: Array,
    phones: Array,
  },

  computed: {
    menuRows() {
      return this.tubes.length;
    },
    rowClass() {},
  },
  updated() {
    this.fields[0].label = this.$t("addModem.tube");
    this.fields[1].label = this.$t("addModem.modemsSN");
    this.options[0].namelabel = this.$t("addModem.serNumber");
    this.options[1].namelabel = this.$t("addModem.fullSerNumber");
  },
  methods: {
    showModal(item) {
      let cont = this;
      function createContForEdit() {
        return new Promise((resolve, reject) => {
          cont.$refs["EditModal"].show();
          cont.editing_tube = item;
          cont.options[0].info = item.serial;
          cont.options[1].info = item.full_serial;
          cont.coords = JSON.stringify(JSON.parse(item.marker).coordinates);
          cont.comment_types[0].info = item.tube_comment;
          cont.comment_types[1].info = item.modem_comment;
          cont.selected_phones = [];
          cont.tube_coords = JSON.parse(item.coordinates);
          cont.modem_coords = JSON.parse(item.marker);
          for (let key in item.phones) {
            cont.selected_phones.push("" + item.phones[key].phone + "");
          }
          resolve("success");
        });
      }
      const promise = createContForEdit();
      promise
        .then((result) => {
          cont.tube_coords = JSON.parse(item.coordinates);
          cont.map = L.map("map", { editable: true }).setView(
            [
              cont.tube_coords.coordinates[0][1],
              cont.tube_coords.coordinates[0][0],
            ],
            17
          );
          setTimeout(function () {
            cont.map.invalidateSize();
          }, 40);
          cont.map.baseLayer = L.tileLayer(
            "https://api.tiles.mapbox.com/v4/{id}/{z}/{x}/{y}.png?access_token=pk.eyJ1IjoiZGFyeWFjaHlydWsiLCJhIjoiY2swbzEwNnlrMDViYzNrcXI4NDAyN2gyNiJ9.d5mwHr6_wkJRtV0aXZv7Mg",
            {
              attribution: "&copy",
              maxZoom: 18,
              id: "mapbox.streets",
              accessToken:
                "pk.eyJ1IjoiZGFyeWFjaHlydWsiLCJhIjoiY2swbzEwNnlrMDViYzNrcXI4NDAyN2gyNiJ9.d5mwHr6_wkJRtV0aXZv7Mg",
            }
          ).addTo(cont.map);
        })
        .then(() => {
          let latlngcoords = [];
          for (let i = 0; i < cont.tube_coords.coordinates.length; i++) {
            latlngcoords[i] = [];
            latlngcoords[i][0] = cont.tube_coords.coordinates[i][1];
            latlngcoords[i][1] = cont.tube_coords.coordinates[i][0];
          }
          cont.line = L.polyline(latlngcoords).addTo(cont.map);
          cont.line.enableEdit();

          let latlngmarker = [];
          latlngmarker[0] = cont.modem_coords.coordinates[1];
          latlngmarker[1] = cont.modem_coords.coordinates[0];
          cont.marker = L.marker(latlngmarker).addTo(cont.map);
          cont.marker.enableEdit();
        });
    },

    editModemTube() {
      let cont = this;
      cont.editing_tube.serial = cont.options[0].info;
      cont.editing_tube.full_serial = cont.options[1].info;
      cont.editing_tube.tube_comment = cont.comment_types[0].info;
      cont.editing_tube.modem_comment = cont.comment_types[1].info;
      let new_phones = [];
      for (let i = 0; i < cont.selected_phones.length; i++) {
        new_phones[i] = { phone: cont.selected_phones[i] };
      }
      cont.editing_tube.phones = JSON.stringify(new_phones);

      let new_coordinates = [];
      for (let i = 0; i < cont.line._latlngs.length; i++) {
        new_coordinates[i] = [];
        new_coordinates[i][0] = cont.line._latlngs[i].lng;
        new_coordinates[i][1] = cont.line._latlngs[i].lat;
      }

      let new_marker = [];
      new_marker[0] = cont.marker._latlng.lng;
      new_marker[1] = cont.marker._latlng.lat;

      cont.editing_tube.coordinates = JSON.stringify({
        type: "LineString",
        coordinates: new_coordinates,
      });

      // cont.editing_tube.marker = JSON.stringify({
      //   type: "Point",
      //   coordinates: new_marker,
      // });
      cont.editing_tube.marker = Page4_addmodem.methods.get_coordinates(cont.coords);

      this.$API(
        "modems",
        "editModemTube",
        cont.editing_tube,
        function (data) {
          if (data.element == "absent") {
            cont.message =
              "Изменяемый модем отсутствует либо используется на другом участке!";
          } else {
            cont.message = "Участок успешно отредактирован!";
          }
          cont.showMessage();
          cont.editing_tube = null;
        },
        function (errorText) {
          console.log(errorText);
        }
      );
    },

    hideModal() {
      this.$emit("updateTubeList");
      this.$refs["EditModal"].hide();
    },

    showMessage() {
      this.$refs["messageModal"].show();
    },

    hideMessage() {
      this.$refs["messageModal"].hide();
      this.hideModal();
    },

    showDeleteModal(item) {
      this.message = "Вы действительно хотите удалить участок?";
      this.editing_tube = null;
      this.editing_tube = item;
      this.$refs["deleteModal"].show();
    },

    hideDeleteModal() {
      this.$refs["deleteModal"].hide();
    },

    deleteTube() {
      let cont = this;
      this.$API(
        "modems",
        "deleteModemTube",
        cont.editing_tube,
        function (data) {
          cont.$emit("updateTubeList");
        },
        function (errorText) {
          console.log(errorText);
        }
      );
      this.hideDeleteModal();
    },
  },
  template: Template,
};

export { Left_menu };



// WEBPACK FOOTER //
// ./src/app/js/components/page4_addmodem/left_menu/component.js